export default __webpack_public_path__ + "0fad7ac06684b9e2f103e5c1e86d574d.png";